import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import Pagination from "../utils/Pagination";
import {
  decodeData,
  errorToaster,
  formatDate,
  successToaster,
} from "../utils/Helper";
import { getMethod, postMethod } from "../service";
import { useNavigate } from "react-router-dom";
import Input from "../utils/Input";
import Select from "../utils/Select";
import SubmitBtn from "../utils/SubmitBtn";
import { USER_API } from "../service/constant";
import Switch from "../utils/Switch";

const UserManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [searchRole, setSearchRole] = useState("");
  const [isBanned, setIsBanned] = useState("");
  const [search, setSearch] = useState("");

  const fetchUser = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      const res = await getMethod(
        `${USER_API}?page=${page}&limit=50&search=${search}&is_banned=${isBanned}&role=${searchRole}`,
        token.token
      );
      if (res?.isSuccess) {
        setIsLoading(false);
        setUsers(res?.data);
        res?.meta.current_page && setFrom((res?.meta.current_page - 1) * 50);
        res?.meta.last_page && setTotalPage(res?.meta.last_page);
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [refs, page]);

  const handleSwitchChange = async (id, currentState) => {
    const newState = !currentState;

    setUsers(
      users.map((user) =>
        user._id === id ? { ...user, is_banned: newState } : user
      )
    );

    setIsLoading(true);

    const token = decodeData(localStorage.getItem("r_c_a"));

    if (token) {
      try {
        const res = await postMethod(
          `${USER_API}/${id}`,
          { is_banned: newState },
          token.token
        );

        if (res?.isSuccess) {
          successToaster(res.message);
        } else {
          errorToaster(res?.message);
        }
      } catch (error) {
        errorToaster(error.message);
      } finally {
        setIsLoading(false);
      }
    } else {
      errorToaster("Unauthenticated!");
    }
  };

  return (
    <Template title="Users" isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1">
            <Input
              type="text"
              value={search}
              event={(e) => setSearch(e.target.value)}
              placeholder="Search"
            />
          </div>
          <div className="col-12 col-md-4 px-1">
            <Select value={isBanned} event={(e) => setIsBanned(e.target.value)}>
              <option value="">Select Status</option>
              <option value="true">Is Banned</option>
              <option value="false">Allowed User</option>
            </Select>
          </div>
          <div className="col-12 col-md-4 px-1">
            <Select
              value={searchRole}
              event={(e) => setSearchRole(e.target.value)}
            >
              <option value="">Select Role</option>
              <option value="admin">Admin</option>
              <option value="user">User</option>
            </Select>
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Balance</th>
              <th>Status</th>
              <th>Action</th>
              <th>Reg Date & Time</th>
            </TableHeader>
            <TableBody>
              {users.length > 0 &&
                users.map((user, i) => (
                  <tr key={user.id} style={{ verticalAlign: "middle" }}>
                    <td>{i + from + 1}</td>

                    <td>{user?.name}</td>
                    <td>{user?.phone}</td>
                    <td className="text-end">
                      {user?.balance.toLocaleString()}
                    </td>

                    <td>
                      {user?.is_banned ? (
                        <i
                          className="bi-circle-fill text-danger"
                          style={{ fontSize: "10px" }}
                        />
                      ) : (
                        <i
                          className="bi-circle-fill"
                          style={{ fontSize: "10px", color: "green" }}
                        />
                      )}
                    </td>
                    <td>
                      <Switch
                        status={!user?.is_banned}
                        event={() =>
                          handleSwitchChange(user._id, user.is_banned)
                        }
                        bg_color={!user?.is_banned ? "#4CAF50" : "#f44336"}
                        id={`switch-${user._id}`}
                      />
                    </td>
                    <td>{formatDate(user?.createdAt) ?? "- -"}</td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
      {/* {editModal && (
        <ActionModal
          name={"Edit User"}
          onClose={() => setEditModal(false)}
          onSubmit={() => editSubmitHandler()}
        >
          <Form>
            <Input
              type={"password"}
              title={"New Password"}
              placeholder={"Enter New Password"}
              value={password}
              event={(e) => setPassword(e.target.value)}
            />
            <Select
              value={userStatus}
              event={(e) => setUserStatus(e.target.value)}
              title={"Choose Status"}
            >
              <option value="">Choose Status</option>
              <option value="active">Active</option>
              <option value="disable">Disable</option>
            </Select>
          </Form>
        </ActionModal>
      )} */}
    </Template>
  );
};

export default UserManagement;
